import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ palette,variables }) => ({
  orderDetailCardWrapper: {

  },
  orderDetailCardDetailItem: {
    listStyle: 'none',
    padding: '0',
    display: 'flex',
    flexDirection: 'column',
    gap: variables?.spacingC,
    paddingTop: variables?.spacingD,
    borderBottom: `1px solid ${palette.jet?.dividerDefault}`,
    paddingBottom: variables?.spacingD,
    '& li': {
        listStyle: 'none',
        display:'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: variables?.spacingB,
        '&:last-child': {
            //alignItems: 'flex-start',
        }
    }

  },
  orderDetailIcons: {
        width:'32px',
        height: '32px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
  },
  orderDetailAddress: {
    display:'flex',
    flexDirection: 'column',
    width: 'calc(100% - 32px)',
    //width:'100%'
    '& p': {
      wordBreak: 'break-word'
    }

  },
  orderDetailComment: {
    lineHeight:'20px',
    maxHeight:'100px',
    overflow:'auto',
    width: 'calc(100% - 32px)',
    //width:'100%'
    '& p': {
      wordBreak: 'break-word'
    }
  },
  skeletonLoader: {
    backgroundColor: `${palette.jet?.containerSubtle} !important` ,
    borderRadius: `${variables?.radiusRoundedC} !important`
   },
   orderDetailItemsWrapper: {
    display:'flex',
    flexDirection: 'column',
    gap: variables?.spacingC,
    maxHeight: '465px',
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingBottom: variables?.spacingD
   }
}));

export default styles;
